export default "__VITE_ASSET__DULCvjFY__"